import { StripePlan } from "../types/billing";
import { getRecoil } from "../providers/RecoilAccessProvider";
import { dangerousCompanyState } from "../states/accountState";

export const isLocationOnlyPlan = (plan: StripePlan | undefined): boolean => {
    return plan === "business_location_yr" || plan === "business_location_mo";
}

export const retrieveCompany = () => getRecoil(dangerousCompanyState);